import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../../publicLayout/components/HorizontalLayoutContainer';
import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import PublicCatalogDropdown from './PublicCatalogDropdown';
import { dropdownFilters } from '../publicCatalogConstants';
import { useGetMainFilterApplied, useGetPathFilterApplied } from '../publicCatalogFiltersHooks';
import { getSubMenuNameFromSubMenuOption } from '../publicCatalogDropdownUtils';
import { useGetDropdownFilterApplied } from '../publicCatalogFiltersHooks';
import PublicCatalogResultsText from './PublicCatalogResultsText';
import { useGetCatalogResultsFromUrlFilters } from '../publicCatalogResultsHooks';
import { PAGE_SIZE } from './PublicCatalogResults';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResultsBar = styled.div.withConfig({
  displayName: "PublicCatalogResultsBar__ResultsBar",
  componentId: "sc-179v31y-0"
})(["background-color:", ";min-height:40px;color:", ";"], theme.colors.CALYPSO_DARK, theme.colors.OLAF);
const ResultsBarDropdowns = () => {
  const dropdownFilterAppliedInfo = useGetDropdownFilterApplied();
  const pathFilterApplied = useGetPathFilterApplied();
  if (pathFilterApplied) {
    return /*#__PURE__*/_jsx(PublicCatalogDropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.pathFilters.${pathFilterApplied}`
      }),
      buttonUse: "link-on-dark"
    });
  }
  if (!dropdownFilterAppliedInfo) return null;
  const {
    dropdownFilterApplied,
    dropdownFilterValue,
    isAppliedValueATopLevelOption
  } = dropdownFilterAppliedInfo;
  if (isAppliedValueATopLevelOption) {
    return /*#__PURE__*/_jsx(PublicCatalogDropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${dropdownFilterApplied}.${dropdownFilterValue}`
      }),
      buttonUse: "link-on-dark"
    });
  }
  const subMenuName = getSubMenuNameFromSubMenuOption(dropdownFilterApplied, dropdownFilterValue);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PublicCatalogDropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${dropdownFilterApplied}.${subMenuName}`
      }),
      buttonUse: "link-on-dark"
    }), /*#__PURE__*/_jsx("span", {
      className: "m-x-2",
      children: "/"
    }), /*#__PURE__*/_jsx(PublicCatalogDropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyPublic.catalogPage.filters.${dropdownFilterApplied}.${dropdownFilterValue}`
      }),
      buttonUse: "link-on-dark",
      subMenuName: subMenuName || undefined
    })]
  });
};
const ResultsBarsSkeletonLoader = () => /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
  children: /*#__PURE__*/_jsx("div", {
    "data-test-id": "results-bar-loading",
    children: /*#__PURE__*/_jsx(ACSkeletonBox, {
      animated: true,
      backgroundcolor: theme.colors.CALYPSO_DARK,
      shimmercolor: theme.colors.CALYPSO_MEDIUM,
      style: {
        width: '180px',
        height: '20px'
      }
    })
  })
});
const PublicCatalogResultsBar = () => {
  const [searchParams] = useSearchParams();
  const mainFilterApplied = useGetMainFilterApplied();
  const pathFilterApplied = useGetPathFilterApplied();
  const {
    publicCatalogData,
    publicCatalogError,
    publicCatalogLoading
  } = useGetCatalogResultsFromUrlFilters({
    pageSize: PAGE_SIZE
  });
  return /*#__PURE__*/_jsxs(ResultsBar, {
    className: "p-y-2",
    children: [publicCatalogLoading && /*#__PURE__*/_jsx(ResultsBarsSkeletonLoader, {}), !publicCatalogLoading && !publicCatalogError && publicCatalogData && /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        children: [/*#__PURE__*/_jsx(UIBox, {
          shrink: 0,
          children: /*#__PURE__*/_jsx(PublicCatalogResultsText, {
            count: publicCatalogData.total || 0
          })
        }), /*#__PURE__*/_jsxs(UIBox, {
          className: "m-left-2",
          children: [mainFilterApplied === 'search' && /*#__PURE__*/_jsx(UITruncateString, {
            style: {
              display: 'inline'
            },
            children: searchParams.search
          }), ' ', (dropdownFilters.includes(mainFilterApplied) || pathFilterApplied) && /*#__PURE__*/_jsx(ResultsBarDropdowns, {})]
        })]
      })
    })]
  });
};
export default PublicCatalogResultsBar;